<template>
  <transition name="fade">
    <div v-if="visible" class="toast">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      duration: 3000
    }
  },
  mounted() {
    // 将Toast组件移动到body下，避免父容器overflow的影响
    if (this.$el && this.$el.parentNode) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy() {
    // 组件销毁前从body中移除
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    /**
     * 显示Toast消息
     * @param {string} message - 要显示的消息内容
     * @param {number} duration - 显示持续时间，默认3000毫秒
     */
    show(message, duration = 3000) {
      this.message = message
      this.duration = duration
      this.visible = true

      setTimeout(() => {
        this.hide()
      }, this.duration)
    },
    /**
     * 隐藏Toast消息
     */
    hide() {
      this.visible = false
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  z-index: 99999;
  font-size: 12px;
  /* 确保Toast不受父容器的overflow等属性影响 */
  pointer-events: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>